import { IContent } from "../../HubFramework";
import Overview from "./Tabs/Overview";
import { odxIconSets } from "../../OdxComponents/constants";
import { UserRoles } from "../../Utils";
import Secrets from "./Tabs/Secrets";
import Info from "./Tabs/Info";

export const moduleContent: IContent = {
    moduleName: "gitHubEnterpriseDrg",
    title: "GitHub Enterprise",
    pages: [
        {
            displayName: "Repositories",
            contentPage: Overview,
            minimumRole: UserRoles.reader,
            icon: { name: "folder", iconSet: odxIconSets.core }
        },
        {
            displayName: "Secrets",
            contentPage: Secrets,
            minimumRole: UserRoles.reader,
            icon: { name: "lock", iconSet: odxIconSets.core }
        },
        {
            displayName: "Info",
            contentPage: Info,
            minimumRole: UserRoles.reader,
            icon: { name: "info", iconSet: odxIconSets.core }
        }
    ],
    defaultPage: "Overview",
    creationProps: []
};
